"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var react_hook_form_1 = require("react-hook-form");
var react_i18next_1 = require("react-i18next");
var InputDirectionEnum_1 = require("../../../../../enums/InputDirectionEnum");
var CalculatorContextInterface_1 = require("../CalculatorContextInterface");
var CalculatorInputReciveView = function (props) {
    var _a = (0, CalculatorContextInterface_1.useCalculatorContext)(), server = _a.server, payRecive = _a.payRecive, setInputDirection = _a.setInputDirection, payAmount = _a.payAmount, payReciveDiscount = _a.payReciveDiscount, sale = _a.sale, setPayRecive = _a.setPayRecive;
    var _b = (0, react_hook_form_1.useFormContext)(), register = _b.register, setValue = _b.setValue, errors = _b.formState.errors;
    var _c = (0, react_i18next_1.useTranslation)(), t = _c.t, i18n = _c.i18n;
    var _d = (0, react_1.useState)(0), inputValue = _d[0], setInputValue = _d[1];
    var _e = (0, react_1.useState)(), minOrder = _e[0], setMinOrder = _e[1];
    function handleReciveKeyChange(e) {
        var regex = /[0-9]|\./;
        if (!regex.test(e.key)) {
            e.preventDefault();
        }
    }
    function handleFocus() {
        setInputDirection(InputDirectionEnum_1.InputDirectionEnum.COINTS);
    }
    (0, react_1.useEffect)(function () {
        if (server && !sale) {
            var min = (server.min_order / server.default_price).toFixed(2);
            setMinOrder(parseFloat(min));
        }
    }, [server]);
    (0, react_1.useEffect)(function () {
        if (sale) {
            setMinOrder(0);
            //setValue('pay_recive', payRecive)
        }
    }, [sale]);
    (0, react_1.useEffect)(function () {
        //console.log("payRecive",payRecive);
        (payRecive)
            ? setValue('pay_recive', payRecive)
            : setValue('pay_recive', undefined);
    }, [payRecive]);
    (0, react_1.useEffect)(function () {
        //console.log("payRecive erorrs",errors.pay_recive);
    }, [errors.pay_recive]);
    (0, react_1.useEffect)(function () {
        //console.log("minOtder",minOrder);
    }, [minOrder]);
    return (react_1.default.createElement("div", { className: "__wrap-item" },
        react_1.default.createElement("div", { className: "__wrap-top-item" }, errors.pay_recive
            ?
                react_1.default.createElement("div", { className: "__has-error" },
                    t("calculator.recive.error.emty"),
                    " ",
                    minOrder ? minOrder.toFixed(2) : '')
            :
                react_1.default.createElement(react_1.Fragment, null,
                    react_1.default.createElement("div", { className: "__top-notification" }, t("calculator.recive.input.caption")))),
        react_1.default.createElement("div", { className: (0, classnames_1.default)("__input-icon-wrap-full", errors.pay_recive ? "__error" : "", payRecive ? "__succeess" : "") },
            react_1.default.createElement("div", { className: "__wrap_coins_input" },
                react_1.default.createElement("input", __assign({}, register("pay_recive", {
                    required: true,
                    valueAsNumber: true,
                    validate: {
                        positive: function (v) { return parseInt(v) > 0; },
                        minOrder: function (v) { return (minOrder || minOrder === 0) ? parseFloat(v) >= minOrder : false; },
                    },
                    onChange: function (e) { setPayRecive(parseFloat(e.target.value)); }
                }), { onKeyPress: handleReciveKeyChange, onFocus: handleFocus, autoComplete: "off", placeholder: t("calculator.recive.input.placeholder") })),
                react_1.default.createElement("span", { className: "__measurements" }, (server === null || server === void 0 ? void 0 : server.measurements) && t(server.measurements)))),
        payRecive && payReciveDiscount && (payReciveDiscount > payRecive) &&
            react_1.default.createElement("div", { className: "__wrap-bottom-item" },
                react_1.default.createElement("div", { style: { background: "#28b160" }, className: "__has-error __coins" },
                    t("calculator.recive.input.bottom"),
                    "  ",
                    payReciveDiscount ? payReciveDiscount.toFixed(2) : ' ',
                    " ",
                    (server === null || server === void 0 ? void 0 : server.measurements) && t(server.measurements),
                    " ", server === null || server === void 0 ? void 0 :
                    server.app_locale_currency))));
};
exports.default = CalculatorInputReciveView;
